<template>
  <div class="modal-page-container">
    <LoadingScreen v-if="saveLoading"></LoadingScreen>

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="modal-page-control">
        <span
          class="close"
          @click="
            $router
              .push({
                query: {
                  type: $route.query.type,
                  q: $route.query.q,
                  p: $route.query.p,
                  s: $route.query.s,
                },
              })
              .catch(() => {}),
              $emit('cancel')
          "
        >
          <i class="fa-regular fa-times"></i>
        </span>

        <div class="control-area">
          <div class="grids is-2-desktop gap-20-desktop">
            <div class="field">
              <label class="label">Post Date</label>

              <div class="control">
                <ValidationProvider
                  name="OpeningDate"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <date-picker
                    type="date"
                    :disabled-date="notBeforeToday"
                    v-model="openingDate"
                    valueType="date"
                    :clearable="false"
                    @change="periodKeychange"
                    :class="{ error: errors[0] }"
                  />
                </ValidationProvider>
              </div>
            </div>

            <div class="field">
              <label class="label">Expire Date</label>

              <div class="control">
                <ValidationProvider
                  name="ClosingDate"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <date-picker
                    type="date"
                    v-model="closingDate"
                    valueType="date"
                    :clearable="false"
                    :class="{ error: errors[0] }"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="buttons">
            <button
              class="button"
              @click="
                $router
                  .push({
                    query: {
                      type: $route.query.type,
                      q: $route.query.q,
                      p: $route.query.p,
                      s: $route.query.s,
                    },
                  })
                  .catch(() => {}),
                  $emit('cancel')
              "
            >
              Cancel
            </button>

            <button
              class="button primary"
              @click.prevent="handleSubmit(savePinJob)"
              v-if="!$route.query.id"
            >
              Post Job
            </button>

            <button
              class="button primary"
              @click.prevent="handleSubmit(updatePinJob)"
              v-if="$route.query.id"
            >
              Update Job
            </button>
          </div>
        </div>
      </div>

      <div class="modal-page-content">
        <div class="page-header">
          <h3 class="page-title">POST PIN JOB</h3>
        </div>

        <!-- Select Company Start -->

        <div class="box">
          <div class="search-label">
            <ValidationProvider
              name="Company"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="select-company">
                <span
                  v-if="!getSelectedCompany"
                  @click="search = true"
                  class="placeholder"
                  :class="{ error: errors[0] }"
                >
                  Select Company
                  <label class="error_text">*</label>
                </span>

                <p @click="search = true">
                  {{ getSelectedCompany ? getSelectedCompany.companyName : "" }}
                </p>

                <input type="text" v-model="employerId" hidden="hidden" />
              </div>

              <div
                class="seach-box"
                v-if="search"
                v-click-outside="() => chooseCompany()"
              >
                <span class="search-box-title">
                  <span style="color: white">Please select the company</span>

                  <span @click="search = false">
                    <i
                      style="color: white"
                      class="far fa-times-circle close-btn"
                    ></i>
                  </span>
                </span>

                <div class="search">
                  <input
                    v-model="searchText"
                    type="text"
                    class="input"
                    placeholder="Company name"
                  />
                </div>

                <div class="search-list">
                  <div
                    @click="chooseCompany(c._id, index)"
                    class="search-item"
                    v-for="(c, index) in getFilteredCompany"
                    :key="index"
                  >
                    <p>{{ c.companyName }}</p>
                  </div>
                </div>
              </div>
            </ValidationProvider>
          </div>
        </div>

        <!-- Select Company End -->

        <!-- Post Image and Job Title Start -->

        <div class="grids is-5-desktop gap-20-desktop">
          <div class="box span-2-desktop">
            <div class="jobpost-image">
              <div class="file is-centered">
                <div v-if="uploading" class="uploadings">
                  <img
                    src="../../assets/image_processing20200330-7332-hqwaa9.gif"
                  />
                </div>

                <div
                  class="logo"
                  :style="{ 'background-image': `url( ${imageData} )` }"
                  @click="chooseImage"
                >
                  <div class="upload-btn">
                    <i class="fas fa-camera"></i>
                  </div>
                </div>
              </div>

              <input
                class="isFile"
                name="profile"
                ref="fileinput"
                type="file"
                @input="onSelectFile"
              />

              <div
                class="container has-text-centered"
                v-if="selectFiles == true"
              >
                <span style="color: red; font-size: 12px">
                  {{ checkImageUpload }}
                </span>
              </div>
            </div>

            <div class="container has-text-centered">
              <ValidationProvider
                name="image"
                rules="required"
                v-slot="{ errors }"
              >
                <input type="text" style="display: none" v-model="file" />

                <span style="color: red; font-size: 12px">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="box span-3-desktop">
            <ValidationProvider
              name="Job Title"
              rules="required"
              v-slot="{ errors }"
              tag="ul"
              class="job-title-list"
            >
              <li v-for="(i, index) in titles" :key="index">
                <p>
                  <input
                    class="input"
                    v-model="titles[index].title"
                    type="text"
                    placeholder="Job Title"
                    :class="{ error: errors[0] }"
                  />
                </p>

                <p>
                  <input
                    class="input"
                    v-model="titles[index].qty"
                    type="number"
                    placeholder="QTY"
                    v-on:keyup.enter="titles.push({})"
                    :class="{ error: errors[0] }"
                  />

                  <span class="Trash">
                    <i
                      class="fas fa-trash"
                      style="cursor: pointer"
                      @click="titles.splice(index, 1)"
                      v-if="index !== 0"
                    ></i>
                  </span>
                </p>
              </li>
            </ValidationProvider>

            <button
              class="button primary"
              v-if="titles.length < 100"
              @click="titles.push({})"
            >
              Add more
            </button>
          </div>
        </div>

        <!-- Post Image and Job Title End -->

        <!-- Link to Facebook Post Start -->

        <div class="box">
          <div class="field">
            <label class="label">Link to Facebook Post</label>

            <div class="control">
              <input
                type="text"
                v-model="facebookLink"
                class="input"
                placeholder="Facebook link "
              />
            </div>
          </div>
        </div>

        <!-- Link to Facebook Post End -->

        <!-- Job Function Start-->

        <div class="box">
          <div class="field">
            <label class="label">Job Function</label>

            <div class="control">
              <div class="search-label">
                <ValidationProvider
                  name="jobFunction"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div>
                    <span
                      @click="searchJobFunctions = true"
                      class="placeholder"
                      :class="{ error: errors[0] }"
                    >
                      Select Job Function
                      <label class="error_text">*</label>
                    </span>

                    <input
                      type="text"
                      v-model="jobFunction_Id"
                      hidden="hidden"
                    />
                  </div>

                  <div
                    class="seach-box"
                    v-if="searchJobFunctions"
                    v-click-outside="() => chooseJobFunction()"
                  >
                    <span class="search-box-title">
                      <span style="color: white">
                        Please choose the Job Function
                      </span>

                      <span @click="searchJobFunctions = false">
                        <i
                          style="color: white"
                          class="far fa-times-circle close-btn"
                        ></i>
                      </span>
                    </span>

                    <div class="search">
                      <input
                        v-model="searchTextJobF"
                        type="text"
                        class="input"
                        placeholder="name"
                      />
                    </div>

                    <div class="search-list">
                      <div
                        @click="chooseJobFunction(c._id, index)"
                        class="search-item"
                        v-for="(c, index) in getFilteredJobFunction"
                        :key="index"
                      >
                        <p>{{ c.name }}</p>
                      </div>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <ul class="selected-list">
            <li v-for="(i, index) in jobFunctionId" :key="index">
              <p>{{ i.name }}</p>

              <span @click="removeJobFunctions(i, index)">
                <i class="fa-light fa-xmark"></i>
              </span>
            </li>
          </ul>
        </div>

        <!-- Job Function End -->

        <!-- Tags / Keywords Start -->

        <div class="box">
          <div class="field">
            <label class="label">Tags / Keywords</label>

            <div class="control">
              <input
                type="text"
                v-model="searchTags"
                @keyup.enter="searchItems"
                class="input"
                placeholder="Enter keyword and press ENTER"
              />
            </div>
          </div>

          <ul class="selected-list keyword-list">
            <li v-for="(i, index) in tags" :key="index">
              <p>{{ i }}</p>

              <span @click="remove(index)">
                <i class="fa-light fa-xmark"></i>
              </span>
            </li>
          </ul>
        </div>

        <!-- Tags / Keywords End -->

        <!-- Job Description Start -->

        <div class="box">
          <div class="field">
            <label class="label">Job Description</label>

            <div class="control">
              <ValidationProvider
                name="description"
                rules="required"
                v-slot="{ errors }"
              >
                <div v-if="!isLoading">
                  <FroalaEditor
                    v-model="description"
                    :class="{ error: errors[0] }"
                  />
                </div>

                <FroalaEditor
                  v-if="isLoading"
                  v-model="description"
                  :class="{ error: errors[0] }"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>

        <!-- Job Description End -->

        <!-- Upload Share Image -->

        <div class="box">
          <label for="" class="label">Facebook share image</label>

          <div class="facebook-share-image">
            <div v-if="shareImgload" class="uploadingShareImage">
              <img
                src="../../assets/image_processing20200330-7332-hqwaa9.gif"
              />
            </div>

            <div class="image" @click="chooseShareImage">
              <img :src="dataImage" alt="" />

              <div class="icon">
                <i class="fas fa-camera"></i>
              </div>
            </div>

            <input
              class="isFile"
              name="profiles"
              ref="fileinputs"
              type="file"
              @input="onSelectShareImage"
            />

            <div
              class="container has-text-centered"
              v-if="selectShareImage == true"
            >
              <span style="color: red; font-size: 12px">
                {{ checkShareImageUpload }}
              </span>
            </div>
          </div>

          <div class="container has-text-centered">
            <!-- <ValidationProvider name="Images" rules="required" v-slot="{ errors }"> -->

            <input type="text" style="display: none" v-model="shareImage" />

            <!-- <span style="color: red; font-size: 12px">{{ errors[0] }}</span> -->

            <!-- </ValidationProvider> -->
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import vClickOutside from "v-click-outside";
import "vue2-datepicker/index.css";
import axios from "axios";
import { JOBFUNCTIONLIST } from "@/graphql/PinJob/JobfunctionList";
import { addPinJobAPIS, updatePinJob } from "@/apis/Pin-Job";
import { apolloClient } from "@/services/apollo-client";
import selection from "../../components/others/selection";
import FroalaEditor from "../../components/others/FroalaEditor";
import { getEmployersApi } from "@/apis/employer-api";
import { editPinJobAPIS } from "@/apis/Pin-Job";
import LoadingScreen from "@/components/others/Loading";
export default {
  components: {
    selection,
    DatePicker,
    FroalaEditor: FroalaEditor,
    LoadingScreen,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: () => ({
    titles: [
      {
        title: "",
        qty: null,
      },
    ],
    file: null,
    companies: [],
    facebookLink: "",
    jobFunctionId: [],
    description: "",
    employerId: "",
    tags: [],
    openingDate: null,
    closingDate: null,
    search: false,
    searchText: "",
    isLoading: true,
    //upload image variable
    imageData: null,
    selectFiles: false,
    checkImageUpload: null,
    //job function
    searchJobFunctions: false,
    searchTextJobF: "",
    jobFunction_Id: "",
    jobFunctions: [],
    // tag or keyword
    searchTags: "",
    errorMsg: "",
    //loading
    saveLoading: false,
    uploading: false,
    // upload share image
    shareImgload: false,
    dataImage: null,
    checkShareImageUpload: null,
    shareImage: null,
    selectShareImage: false,
  }),
  computed: {
    getSelectedCompany() {
      return this.companies.find((i) => {
        return i._id === this.employerId;
      });
    },
    getFilteredCompany() {
      return this.companies.filter((i) => {
        return i.companyName.toLowerCase().match(this.searchText.toLowerCase());
      });
    },
    getSelectedJobFunction() {
      return this.jobFunctions.find((i) => {
        return i._id === this.jobFunction_Id;
      });
    },
    getFilteredJobFunction() {
      return this.jobFunctions.filter((i) => {
        return i.name.toLowerCase().match(this.searchTextJobF.toLowerCase());
      });
    },
  },
  methods: {
    //calculate date
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    periodKeychange() {
      this.closingDate = moment(this.openingDate).add(7, "days")._d;
    },
    //company function
    chooseCompany(companyId) {
      this.search = false;
      this.employerId = companyId;
    },
    async fetchCompany() {
      const companies = await getEmployersApi();
      this.companies = companies;
    },
    //image function
    chooseImage() {
      this.$refs.fileinput.click();
    },
    chooseShareImage() {
      this.$refs.fileinputs.click();
    },
    async onSelectFile() {
      this.selectFiles = true;
      const input = this.$refs.fileinput;
      const files = input.files;
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file);
      this.uploading = true;
      axios.defaults.headers.common["Authorization"] =
        this.$store.getters.Token;
      const res = await axios.post(`${this.$pinJobURL}`, formData);
      this.file = res.data.fileKey;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input is-focused", files[0]);
      }
      if (this.file) {
        this.checkImageUpload = null;
        this.uploading = false;
      } else {
        this.uploading = false;
        this.checkImageUpload = "Select File Type .JPG .PNG .JPEG .SVG";
      }
    },
    async onSelectShareImage() {
      this.selectShareImage = true;
      const input = this.$refs.fileinputs;
      const files = input.files;
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file);
      this.shareImgload = true;
      axios.defaults.headers.common["Authorization"] =
        this.$store.getters.Token;
      const res = await axios.post(`${this.$pinJobURL}`, formData);
      this.shareImage = res.data.fileKey;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.dataImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input is-focused", files[0]);
      }
      if (this.shareImage) {
        this.checkShareImageUpload = null;
        this.shareImgload = false;
      } else {
        this.shareImgload = false;
        this.checkShareImageUpload = "Select File Type .JPG .PNG .JPEG .SVG";
      }
    },
    //jobfunction
    async fetchJobFunction() {
      const res = await apolloClient.query({
        query: JOBFUNCTIONLIST,
      });
      this.jobFunctions = res.data.filterJobFunction;
    },
    chooseJobFunction(jobfunctionId) {
      this.searchJobFunctions = false;
      this.jobFunction_Id = jobfunctionId;
      const isJobFunction = this.jobFunctions.find(
        (i) => i._id === jobfunctionId
      );
      const keywords = isJobFunction.searchTags;
      const check = this.jobFunctionId.find((f) => f === isJobFunction);
      if (check) return;
      this.tags.push(...keywords);
      this.jobFunctionId.push(isJobFunction);
    },
    removeJobFunctions(info, index) {
      const isJobFunction = this.jobFunctions.find((i) => i._id === info._id);
      const keywords = isJobFunction.searchTags;
      const filtered = this.tags.filter(function (e) {
        return this.indexOf(e) < 0;
      }, keywords);
      this.tags = filtered;
      this.jobFunctionId.splice(index, 1);
    },
    // keyword or tags
    searchItems() {
      if (!this.searchTags)
        return (this.errorMsg = "Please fill out the item first!");
      this.errorMsg = "";
      this.tags.push(this.searchTags);
      this.searchTags = "";
    },
    remove(index) {
      this.tags.splice(index, 1);
    },
    // Save Job function
    async savePinJob() {
      this.saveLoading = true;
      const form = {
        titles: this.titles.map((t) => {
          return { title: t.title, qty: Number(t.qty) };
        }),
        file: this.file,
        openingDate: this.openingDate,
        closingDate: this.closingDate,
        facebookLink: this.facebookLink,
        employerId: this.employerId,
        jobFunctionId: this.jobFunctionId.map((i) => i._id),
        tags: this.tags,
        description: this.description,
        shareImage: this.shareImage,
      };
      await addPinJobAPIS(form)
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.saveLoading = false;
              this.$emit("cancel");
            }, 1500);
          }
        })
        .catch((e) => {
          this.saveLoading = false;
          alert("Can not post");
        });
    },
    // edit data function
    async editPinJob() {
      const id = this.$route.query.id;
      if (!id) return;
      const form = { _id: id };
      const res = await editPinJobAPIS(form);
      this.isLoading = false;
      this.openingDate = new Date(res.openingDate);
      this.closingDate = new Date(res.closingDate);
      this.titles = res.titles;
      this.facebookLink = res.facebookLink;
      this.jobFunctionId = res.jobFunctionId;
      this.tags = res.tags;
      this.employerId = res.employerId._id;
      this.file = res.file;
      this.imageData = this.$urlImageShow + res.file;
      this.description = res.description;
      this.jobFunction_Id = res.jobFunctionId; // protect validate
      this.shareImage = res.shareImage;
      this.dataImage = this.$urlImageShow + res.shareImage;
    },
    async updatePinJob() {
      if (this.$route.query.id) {
        this.saveLoading = true;
        const form = {
          _id: this.$route.query.id,
          titles: this.titles.map((t) => {
            return { title: t.title, qty: Number(t.qty) };
          }),
          file: this.file,
          openingDate: this.openingDate,
          closingDate: this.closingDate,
          facebookLink: this.facebookLink,
          employerId: this.employerId,
          jobFunctionId: this.jobFunctionId.map((i) => i._id),
          tags: this.tags,
          description: this.description,
          shareImage: this.shareImage,
        };
        await updatePinJob(form)
          .then((res) => {
            if (res) {
              setTimeout(() => {
                this.saveLoading = false;
                this.$router
                  .push({
                    name: "pin-job",
                    query: {
                      type: this.$route.query.type,
                      q: this.$route.query.q,
                      p: this.$route.query.p,
                      s: this.$route.query.s,
                    },
                  })
                  .catch(() => {});
                this.$emit("cancel");
              }, 1500);
            }
          })
          .catch(async () => {
            this.saveLoading = false;
            await this.$dialog.messageError("Updating has problematic!");
          });
      }
    },
  },
  async created() {
    this.fetchJobFunction();
    this.fetchCompany();
    await this.editPinJob();
  },
};
</script>

<style lang="scss" scoped>
.placeholder {
  .error_text {
    color: red;
  }

  i {
    margin-left: 10px;
    font-size: var(--sm-font);
  }
}

.grids {
  width: auto !important;
}

.modal-page-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: var(--bg-color);
  display: flex;
  overflow-y: auto !important;
  flex-direction: column;

  .modal-page-content {
    padding: 30px;

    .box {
      margin-bottom: 20px !important;
    }
  }

  .modal-page-control {
    background-color: #fff;
    position: sticky;
    display: flex;
    z-index: 999;
    align-items: center;
    top: 0;
    border-bottom: 1px solid var(--border-color);

    .close {
      width: 30px;
      height: 80px;
      background-color: var(--alert-color);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      i {
        color: #fff;
      }
    }

    .control-area {
      display: flex !important;
      padding: 15px 30px !important;
      justify-content: space-between;
      width: 100%;

      .field {
        display: flex;
        align-items: center;
        margin: 0;

        label {
          margin: 0 10px 0 0;
          font-weight: 500;
        }
      }

      .buttons {
        margin: 0;
        display: flex;
        gap: 10px;

        button {
          margin: 0;
        }
      }
    }
  }
}

.jobpost-image {
  max-height: 600px;
  min-height: 300px;
  overflow-y: auto;

  .uploadings {
    position: fixed;
    background-color: white;
    // opacity: 0.5;
    width: 25%;
    max-height: 600px;
    min-height: 500px;
    border-radius: 50px;
    margin-top: 30px;
    text-align: center;
    z-index: 1000;
  }

  .uploadingShareImage {
    position: absolute;
    background-color: white;
    // opacity: 0.5;
    width: 25%;
    max-height: 600px;
    min-height: 500px;
    border-radius: 50px;
    margin-top: 30px;
    text-align: center;
    z-index: 1000;
  }

  img {
    display: block !important;
    width: 100%;
  }

  .file {
    display: flex;
  }

  .logo {
    background-color: var(--light-grey-color);
    position: relative;
    cursor: pointer;
    margin: 0 auto;
    width: 100%;
    max-height: 700px;
    min-height: 500px;
    overflow-y: auto;
    background-size: contain;
    background-position: center center;
    padding: 20px;
    border: 1px solid var(--border-color);
    background-repeat: no-repeat;

    &:hover .upload-btn {
      opacity: 1;
    }

    .upload-btn {
      transition: opacity 0.3s;
      opacity: 0;
      background-color: rgba(#333, 0.1);
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      text-align: center;

      i {
        padding: 5px;
        font-size: 20px;
      }
    }
  }

  .label {
    margin-top: 10px;
  }

  .isFile {
    display: none;
  }
}

.facebook-share-image {
  background-color: var(--light-grey-color) !important;
  max-height: 250px;
  aspect-ratio: 1.91/1;

  .image {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover .icon {
      display: flex !important;
    }

    .icon {
      background-color: rgba(#000, 0.1);
      z-index: 999;
      width: 100%;
      height: 30px;
      position: absolute;
      bottom: 0;
      display: none;
      align-items: center;
      justify-content: center;

      i {
        transition: all ease-in-out 0.1s;
        font-size: var(--md-font);
        color: var(--grey-color);
      }
    }
  }

  input {
    display: none;
  }
}

ul.job-title-list {
  margin-left: 0;

  li {
    display: grid;
    grid-template-columns: 1fr 150px;
    gap: 10px;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    p {
      margin: 0;

      input {
        width: 100%;
      }

      &:nth-child(2) {
        display: flex;
        align-items: center;

        i {
          margin-left: 10px;
        }
      }
    }
  }
}

.selected-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;

  li {
    display: flex;
    margin: 0 !important;
    color: #fff;
    border-radius: 5px;
    font-size: var(--sm-font);

    p {
      background-color: var(--primary-color);
      margin: 0;
      padding: 8px 15px;
      border-radius: 5px 0 0 5px;
    }

    // close icon start
    span {
      background-color: rgba(var(--primary-color-rgb), 0.5);
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0 5px 5px 0;
      cursor: pointer;

      &:hover {
        background-color: var(--alert-color);
        transition: all ease-in-out 0.3s;
      }
    }

    // close icon end
  }

  &.keyword-list {
    p {
      background-color: var(--info-color);
      color: var(--font-color);
    }

    span {
      background-color: rgba(var(--info-color-rgb), 0.5);
      color: var(--font-color);

      &:hover {
        color: #fff;
      }
    }
  }
}

.search-label {
  background-color: var(--light-grey-color);
  // position: absolute;
  border: 1px solid var(--border-color);
  height: 2.5rem;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-left: 10px;
  width: 100%;
  cursor: pointer;
  margin: 0;
  font-size: 16px;
  transition: all ease-in-out 0.2s;
  font-weight: 500;

  .placeholder {
    color: #000;

    &.error {
      color: var(--alert-color);
    }
  }

  .select-company {
    display: flex;

    p {
      font-weight: 700;
      margin-bottom: 0;
      color: var(--primary-color);
    }
  }

  .seach-box {
    z-index: 1;
    position: relative;
    padding-top: 12px;
    width: 50%;
    border-radius: 5px;
    background-color: var(--primary-color);
    box-shadow: 0 0px 20px 5px rgba(var(--grey-color), 0.5);
    top: 1;
    position: absolute;

    .close-btn {
      margin-left: auto;
      cursor: pointer;
    }

    .search-box-title {
      padding: 0 20px;
      display: flex;
      justify-content: space-between;

      &:hover {
        color: inherit;
      }
    }

    .search {
      padding: 10px 20px 20px;

      input {
        background-color: var(--light-grey-color);
        box-shadow: none;
        box-shadow: unset;
        border: none;
        box-shadow: 0px 0px 0px 2px rgba(var(--primary-color), 1);
      }
    }

    .search-list {
      background-color: #fff;
      padding: 20px;
      padding: 0;
      display: block;
      height: 280px;
      overflow-y: scroll;

      .search-item {
        font-size: 14px;
        white-space: pre-line;
        margin: 0;
        padding: 10px 20px;
        transition: all ease-in-out 0.1s;
        cursor: pointer;

        &:not(:last-child) {
          border-bottom: 1px solid var(--border-color);
        }

        &:hover {
          background-color: #dbdbdb;
        }

        p {
          margin: 0;
        }
      }
    }
  }

  // search-box
}

.error {
  border: 2px solid rgb(255, 86, 8);
  color: rgb(255, 80, 15);
}
</style>
